<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane :label="$t('tab.quote_apply_view')">
        <QuotationTaskSearch></QuotationTaskSearch>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.quote_apply_edit')">
        <QuotationTaskEdit></QuotationTaskEdit>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.quote_apply_close')">
        <QuotationTaskClose></QuotationTaskClose>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import QuotationTaskClose from './QuotationTaskClose.vue';
import QuotationTaskEdit from './QuotationTaskEdit.vue';
import QuotationTaskSearch from './QuotationTaskSearch.vue';

export default {
  components: {
    QuotationTaskSearch,
    QuotationTaskEdit,
    QuotationTaskClose
  },
  data() {
    return {
      tab_index: "0"
    }
  },
  mounted() {
    let href = window.location.href.split("?")
    if (href.length > 0) {
      if (href[1] && href[1] == "tab=2")
        this.tab_index = "1"
      else if (href[1] && href[1] == "tab=3")
        this.tab_index = "2"
    }
  }
}
</script>
